import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "../../axiosComponent";
import { serviceUrls } from "../../constant";

// Utility function for common transport data preparation
const prepareTransportData = (data = {}) => {
  const profileDetails = getLocalStorageData("profileDetails");
  return {
    ...data,
    siteId: profileDetails["_SITE"],
    regionId: profileDetails["_REGION"],
    organizationId: profileDetails["_ORGANIZATION_"]["_ID"],
  };
};

// Transport Route Services
export const getRouteList = async (data) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/route/list",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const getRoute = async (entityId) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/route",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const addRoute = async (data) => {
  return await post({
    url: serviceUrls.TRANSPORT_SERVICE + "/route",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const updateRoute = async (data) => {
  return await put({
    url: serviceUrls.TRANSPORT_SERVICE + "/route",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const deleteRoute = async (entityId) => {
  return await del({
    url: serviceUrls.TRANSPORT_SERVICE + "/route",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const updateRouteStatus = async (data) => {
  return await patch({
    url: serviceUrls.TRANSPORT_SERVICE + "/route",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};
